import PopupFormWrapper from "../popupFormWrapper";

const FORM_CODE = "vacancy";

export default function Vacancy() {
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      extraData={({ popupData }) =>
        popupData ? { form_text_22: popupData } : null
      }
      successText="Заявка отправлена."
    />
  );
}
